<div class="rental-create">
  <div class="page-header">
    <button mat-icon-button routerLink="/rentals" aria-label="Назад">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="page-title">Новый прокат</h1>
  </div>

  @if (bookingInfo) {
    <mat-card class="booking-info-card">
      <mat-card-content>
        <div class="info-row">
          <mat-icon>event_note</mat-icon>
          <span>Бронирование #{{ bookingInfo.id }}: {{ bookingInfo.carTitle }} — {{ bookingInfo.clientName }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="rental-form">
    <mat-card class="form-card">
      <mat-card-content>
        <h3 class="section-title">Клиент</h3>
        <app-client-select
          formControlName="client"
          label="Поиск клиента"
          [required]="true">
        </app-client-select>

        <mat-divider class="section-divider"></mat-divider>

        <h3 class="section-title">Автомобиль</h3>
        <app-car-select
          formControlName="car"
          [cars]="availableCars"
          label="Автомобиль"
          [required]="true">
        </app-car-select>

        <mat-divider class="section-divider"></mat-divider>

        <h3 class="section-title">Выдача</h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Место выдачи</mat-label>
          <input matInput formControlName="handoverLocation" required>
          <mat-error *ngIf="form.get('handoverLocation')?.hasError('required')">Укажите место выдачи</mat-error>
          <mat-error *ngIf="form.get('handoverLocation')?.hasError('serverError')">{{form.get('handoverLocation')?.getError('serverError')}}</mat-error>
        </mat-form-field>

        <app-datetime-input
          formControlName="handoverDate"
          dateLabel="Дата выдачи"
          timeLabel="Время"
          [required]="true">
        </app-datetime-input>

        <app-datetime-input
          formControlName="expectedReturnDate"
          dateLabel="Ожидаемая дата возврата"
          timeLabel="Время">
        </app-datetime-input>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Километраж до, км</mat-label>
          <input matInput type="number" formControlName="mileageBefore" required min="0" inputmode="numeric">
          <mat-icon matSuffix>speed</mat-icon>
          <mat-error *ngIf="form.get('mileageBefore')?.hasError('required')">Укажите пробег</mat-error>
          <mat-error *ngIf="form.get('mileageBefore')?.hasError('min')">Пробег не может быть отрицательным</mat-error>
          <mat-error *ngIf="form.get('mileageBefore')?.hasError('serverError')">{{form.get('mileageBefore')?.getError('serverError')}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Уровень топлива, км</mat-label>
          <input matInput type="number" formControlName="fuelLevelBefore" min="0" inputmode="numeric" placeholder="Необязательно">
          <mat-icon matSuffix>local_gas_station</mat-icon>
          <mat-error *ngIf="form.get('fuelLevelBefore')?.hasError('serverError')">{{form.get('fuelLevelBefore')?.getError('serverError')}}</mat-error>
        </mat-form-field>

        <mat-divider class="section-divider"></mat-divider>

        <h3 class="section-title">Дополнительно</h3>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Маршрут</mat-label>
          <input matInput formControlName="route" maxlength="255" placeholder="Например: Сочи — Красная Поляна — Роза Хутор">
          <mat-icon matSuffix>route</mat-icon>
          <mat-error *ngIf="form.get('route')?.hasError('serverError')">{{form.get('route')?.getError('serverError')}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Заметки</mat-label>
          <textarea matInput formControlName="notes" rows="3"></textarea>
        </mat-form-field>

        <mat-divider class="section-divider"></mat-divider>

        <h3 class="section-title">Дополнительные услуги</h3>
        <p *ngIf="extraServices.length === 0" class="empty-hint">Список услуг пуст. Вы можете продолжить без доп. услуг.</p>
        <div formArrayName="extraServices" *ngIf="extraServices.length > 0">
          <div *ngFor="let esGroup of extraServicesForm.controls; let i = index" [formGroupName]="i" class="extra-service-row">
            <mat-checkbox formControlName="selected" class="extra-service-checkbox">
              {{ extraServices[i].name }}
            </mat-checkbox>
            <mat-form-field appearance="outline" class="extra-service-amount">
              <mat-label>Сумма, ₽</mat-label>
              <input matInput type="number" formControlName="amount" min="0.01" step="0.01" inputmode="decimal" placeholder="0.00">
              <mat-icon matSuffix>payments</mat-icon>
              <mat-error *ngIf="esGroup.get('amount')?.hasError('min')">Сумма должна быть больше 0</mat-error>
            </mat-form-field>
          </div>
        </div>

        <mat-divider class="section-divider"></mat-divider>

        <h3 class="section-title">Фото автомобиля до проката</h3>
        <app-image-upload
          formControlName="imagesBefore"
          label="Фото автомобиля до проката"
          emptyHint="Фото не добавлены — можно приложить снимки состояния авто при выдаче">
        </app-image-upload>

        <mat-divider class="section-divider"></mat-divider>

        <h3 class="section-title">Оплата (необязательно)</h3>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Сумма оплаты</mat-label>
          <input matInput type="number" formControlName="paymentAmount" min="0.01" step="0.01" inputmode="decimal" placeholder="Необязательно">
          <mat-icon matSuffix>payments</mat-icon>
          <mat-error *ngIf="form.get('paymentAmount')?.hasError('serverError')">{{form.get('paymentAmount')?.getError('serverError')}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Способ оплаты</mat-label>
          <mat-select formControlName="paymentMethod">
            <mat-option *ngFor="let opt of paymentMethodOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('paymentMethod')?.hasError('serverError')">{{form.get('paymentMethod')?.getError('serverError')}}</mat-error>
        </mat-form-field>

      </mat-card-content>
    </mat-card>

    <button mat-raised-button color="primary" type="submit" class="full-width-btn submit-btn"
            [disabled]="form.invalid || submitting">
      <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
      <span *ngIf="!submitting"><mat-icon>car_rental</mat-icon> Создать прокат</span>
    </button>
  </form>
</div>
